export const validatePassword = (value: string | undefined, t: any) => {
  if (!value) return t('fields.validate.passwordRequired') // Обрабатываем пустое значение

  const hasLowerCase = /[a-z]/.test(value)
  const hasUpperCase = /[A-Z]/.test(value)
  const hasNumber = /\d/.test(value)
  const hasSpecialChar = /[\W_]/.test(value)
  const hasSpaces = /\s/.test(value)

  const missingConditions = []

  if (!hasNumber) missingConditions.push(t('fields.validate.oneNumber'))
  if (!hasUpperCase) missingConditions.push(t('fields.validate.oneUpperCaseLetter'))
  if (!hasLowerCase) missingConditions.push(t('fields.validate.oneLowerCaseLetter'))
  if (!hasSpecialChar) missingConditions.push(t('fields.validate.oneSpecialCharacter'))
  if (hasSpaces) {
    return t('fields.validate.mustNotContainSpaces')
  }

  if (missingConditions.length === 0) return undefined

  return `${t('fields.validate.passwordMustContain')} ${missingConditions.join(', ')}`
}
